exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ranking {\n  margin-bottom: 100px; }\n  .ranking__header {\n    margin-top: 100px;\n    color: #fff; }\n  .ranking__content {\n    color: #ffffff;\n    background-color: rgba(193, 29, 30, 0.824);\n    padding: 15px;\n    border: 10px solid rgba(0, 0, 0, 0.392);\n    margin: 20px 0; }\n  .ranking__list {\n    list-style: none;\n    padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/Projekty/swaythegame/src/app/views/ranking/ranking.component.scss
// module id = ../../../../../src/app/views/ranking/ranking.component.scss
// module chunks = main